class _TvSymbolsManager {
    getCurrentInstrument() {
        return this.currentInstrument;
    }
    setCurrentInstrument(instrument) {
        this.currentInstrument = instrument;
    }
}
export const TvSymbolsManager = new _TvSymbolsManager();
